(() => {
  const header = document.querySelector('[data-site-header]');
  const hero = document.querySelector('.hero');
  if (header) {
    const updateHeaderTone = () => {
      const pastHero = !hero || window.scrollY >= hero.offsetHeight - header.offsetHeight;
      header.classList.toggle('is-past-hero', pastHero);
    };
    updateHeaderTone();
    window.addEventListener('scroll', updateHeaderTone, { passive: true });

    const searchToggles = [...header.querySelectorAll('[data-search-toggle]')];
    const searchCloses = [...header.querySelectorAll('[data-search-close]')];
    const searchPanel = header.querySelector('[data-search-panel]');
    const setSearch = (open) => {
      if (!searchPanel || searchToggles.length === 0) return;
      searchPanel.hidden = !open;
      searchToggles.forEach((toggle) => toggle.setAttribute('aria-expanded', open ? 'true' : 'false'));
      if (open) searchPanel.querySelector('input')?.focus();
    };
    searchToggles.forEach((toggle) => toggle.addEventListener('click', () => setSearch(searchPanel.hidden)));
    searchCloses.forEach((button) => button.addEventListener('click', () => setSearch(false)));

    const mobileToggle = header.querySelector('[data-mobile-menu-toggle]');
    const mobileMenu = header.querySelector('[data-mobile-menu]');
    const mobileClose = header.querySelector('[data-mobile-menu-close]');
    const setMobileMenu = (open) => {
      if (!mobileMenu || !mobileToggle) return;
      mobileMenu.hidden = !open;
      mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('menu-open', open);
      if (open) {
        setSearch(false);
        mobileMenu.querySelector('input')?.focus();
      }
    };
    mobileToggle?.addEventListener('click', () => setMobileMenu(mobileMenu.hidden));
    mobileClose?.addEventListener('click', () => setMobileMenu(false));

    const accountOpen = header.querySelector('[data-account-open]');
    const accountModal = header.querySelector('[data-account-modal]');
    const accountClose = header.querySelector('[data-account-close]');
    const accountTabs = [...header.querySelectorAll('[data-account-tab]')];
    const accountPanels = [...header.querySelectorAll('[data-account-panel]')];
    const setAccountTab = (name) => {
      accountTabs.forEach((tab) => {
        const active = tab.dataset.accountTab === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      accountPanels.forEach((panel) => {
        const active = panel.dataset.accountPanel === name;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };
    const openAccount = () => {
      if (!accountModal) return;
      setAccountTab('login');
      if (typeof accountModal.showModal === 'function') accountModal.showModal();
      else accountModal.setAttribute('open', '');
      document.documentElement.classList.add('modal-open');
    };
    const closeAccount = () => {
      if (!accountModal) return;
      if (typeof accountModal.close === 'function') accountModal.close();
      else accountModal.removeAttribute('open');
      document.documentElement.classList.remove('modal-open');
      accountOpen?.focus();
    };
    accountOpen?.addEventListener('click', openAccount);
    accountClose?.addEventListener('click', closeAccount);
    accountTabs.forEach((tab) => tab.addEventListener('click', () => setAccountTab(tab.dataset.accountTab)));
    accountModal?.addEventListener('click', (event) => {
      if (event.target === accountModal) closeAccount();
    });
    accountModal?.addEventListener('close', () => document.documentElement.classList.remove('modal-open'));

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      setSearch(false);
      setMobileMenu(false);
      if (accountModal?.open) closeAccount();
    });

    header.querySelectorAll('.header-menu-item').forEach((item) => {
      const trigger = item.querySelector('.header-menu-trigger');
      const panel = item.querySelector('.header-dropdown');
      if (!trigger || !panel) return;
      let closeTimer;
      const setOpen = (open) => {
        clearTimeout(closeTimer);
        item.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      item.addEventListener('pointerenter', () => setOpen(true));
      item.addEventListener('pointerleave', () => { closeTimer = setTimeout(() => setOpen(false), 160); });
      trigger.addEventListener('click', () => setOpen(!item.classList.contains('is-open')));
      trigger.addEventListener('focus', () => setOpen(true));
    });
  }

  const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);

  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const setCartDrawer = (open) => {
    if (!cartDrawer) return;
    cartDrawer.hidden = !open;
    document.documentElement.classList.toggle('modal-open', open);
  };
  document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', () => setCartDrawer(true)));
  document.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', () => setCartDrawer(false)));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setCartDrawer(false); });

  const carousels = document.querySelectorAll('[data-carousel]');
  carousels.forEach((carousel) => {
    const slides = [...carousel.querySelectorAll('[data-slide]')];
    const dots = [...carousel.querySelectorAll('[data-carousel-dot]')];
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let active = 0;
    let timer;

    const show = (next) => {
      active = (next + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const selected = index === active;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
        const video = slide.querySelector('video');
        if (selected) video?.play().catch(() => {});
        else video?.pause();
      });
      dots.forEach((dot, index) => {
        const selected = index === active;
        dot.classList.toggle('is-active', selected);
        dot.setAttribute('aria-current', selected ? 'true' : 'false');
      });
    };

    const start = () => {
      if (reduceMotion || slides.length < 2) return;
      clearInterval(timer);
      timer = setInterval(() => show(active + 1), Number(carousel.dataset.interval) || 7000);
    };

    dots.forEach((dot) => dot.addEventListener('click', () => {
      show(Number(dot.dataset.carouselDot));
      start();
    }));
    carousel.addEventListener('mouseenter', () => clearInterval(timer));
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', () => clearInterval(timer));
    carousel.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', () => document.hidden ? clearInterval(timer) : start());
    show(0);
    start();
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });

  document.querySelectorAll('.filter-drawer').forEach((drawer) => {
    drawer.querySelectorAll('[data-filter-close]').forEach((button) => button.addEventListener('click', () => drawer.removeAttribute('open')));
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const items = [...gallery.querySelectorAll('[data-gallery-item]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const showMedia = (index) => {
      items.forEach((item, itemIndex) => {
        const active = itemIndex === index;
        item.classList.toggle('is-active', active);
        item.querySelector('video')?.pause();
      });
      thumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('is-active', thumbIndex === index));
      items[index]?.querySelector('video')?.play().catch(() => {});
      if (window.matchMedia('(max-width: 900px)').matches) {
        const stage = gallery.querySelector('.product-gallery__stage');
        const target = items[index];
        if (stage && target && !target.hidden && typeof stage.scrollTo === 'function') {
          stage.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        }
      }
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(Number(thumb.dataset.galleryThumb))));

    const stage = gallery.querySelector('.product-gallery__stage');
    if (stage) {
      let scrollFrame;
      stage.addEventListener('scroll', () => {
        if (!window.matchMedia('(max-width: 900px)').matches) return;
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(() => {
          const visibleItems = items.filter((item) => !item.hidden);
          if (!visibleItems.length) return;
          const activeItem = visibleItems.reduce((closest, item) => (
            Math.abs(item.offsetLeft - stage.scrollLeft) < Math.abs(closest.offsetLeft - stage.scrollLeft) ? item : closest
          ));
          items.forEach((item) => item.classList.toggle('is-active', item === activeItem));
          thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb.dataset.mediaId === activeItem.dataset.mediaId));
        });
      }, { passive: true });
    }
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
/*
    // Cache all variant data.
const productVariants = {{ product.variants | json }};
const variantInput = document.querySelector('[data-variant-input]');
const colourBtns = document.querySelectorAll('.swatch-btn');
const sizeBtns = document.querySelectorAll('.size-btn');
const currentColourText = document.querySelector('.current-colour');
const currentSizeText = document.querySelector('.current-size');
const stockTextEl = document.querySelector('[data-stock-text]');
let selectedColour = colourBtns[0]?.dataset.optionValue || '';
let selectedSize = sizeBtns[0]?.dataset.optionValue || '';

// Match the selected colour and size to a variant.
function getMatchVariant(colorVal, sizeVal) {
  return productVariants.find(item => {
    return item.options[0] === colorVal && item.options[1] === sizeVal;
  });
}

// Update all related page elements.
function renderVariant(activeVariant) {
  // 1. Update the hidden variant ID used by the cart form.
  variantInput.value = activeVariant.id;

  // 2. Update the browser URL with ?variant=ID.
  const url = new URL(window.location);
  url.searchParams.set('variant', activeVariant.id);
  history.replaceState({}, '', url);

  // 3. Update price, stock copy, and add-to-cart state.
  document.querySelector('[data-product-price]').innerHTML = new Intl.NumberFormat('en-US', {
    style: 'currency', currency: activeVariant.price.currency
  }).format(activeVariant.price / 100);
  stockTextEl.innerText = activeVariant.available ? 'In stock' : 'Sold out';
  document.querySelector('.product-form__submit').disabled = !activeVariant.available;

  // 4. Switch the product hero image and thumbnail.
  if (activeVariant.featured_media?.id) {
    const targetMediaId = activeVariant.featured_media.id;
    document.querySelectorAll('.product-gallery__item').forEach(item => {
      item.classList.toggle('is-active', item.dataset.mediaId == targetMediaId);
    });
    document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
      thumb.classList.toggle('is-active', thumb.dataset.mediaId == targetMediaId);
    });
  }

  // 5. Refresh the selected colour and size labels.
  currentColourText.innerText = selectedColour;
  currentSizeText.innerText = selectedSize;

  // 6. Disable sizes unavailable for the selected colour.
  sizeBtns.forEach(btn => {
    const checkSize = btn.dataset.optionValue;
    const targetVar = getMatchVariant(selectedColour, checkSize);
    btn.disabled = !(targetVar && targetVar.available);
  });
}

// Variant button click handlers.
colourBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    colourBtns.forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    selectedColour = btn.dataset.optionValue;
    const matchVar = getMatchVariant(selectedColour, selectedSize);
    if (matchVar) renderVariant(matchVar);
  });
});

sizeBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    sizeBtns.forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    selectedSize = btn.dataset.optionValue;
    const matchVar = getMatchVariant(selectedColour, selectedSize);
    if (matchVar) renderVariant(matchVar);
  });
});

// Load the default variant on page initialisation.
const defaultVariant = getMatchVariant(selectedColour, selectedSize);
if(defaultVariant) renderVariant(defaultVariant);
*/
    const variantsElement = section.querySelector('[data-product-variants-json]');
    const variantInput = section.querySelector('[data-variant-input]');
    if (!variantsElement || !variantInput) return;
    let variants = [];
    try { variants = JSON.parse(variantsElement.textContent); }
    catch (error) { console.error('TIME OFF: product variant data could not be read.', error); return; }

    const buttons = [...section.querySelectorAll('[data-option-position][data-option-value]')];
    const initialVariant = variants.find((variant) => String(variant.id) === String(variantInput.value));
    const selected = [...(initialVariant?.options || [])];
    const colourPosition = Number(section.dataset.colourPosition || 0);
    const splitLength = section.dataset.splitLength === 'true' && colourPosition > 0;
    const lengthButtons = [...section.querySelectorAll('[data-length-value]')];
    const isLongColour = (value) => /^long\s*:/i.test(String(value || '').trim());
    const baseColour = (value) => String(value || '').replace(/^long\s*:\s*/i, '').trim();
    let selectedLength = splitLength && isLongColour(selected[colourPosition - 1]) ? 'long' : 'short';
    const gallery = section.querySelector('[data-product-gallery]');
    const stage = gallery?.querySelector('.product-gallery__stage');
    const price = section.querySelector('[data-product-price]');
    const stock = section.querySelector('[data-stock-status]');
    const addButtons = [section.querySelector('[data-add-to-cart]'), section.querySelector('[data-sticky-add]')];
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const addLabel = section.dataset.addToCartLabel || 'Add to cart';
    const soldOutLabel = section.dataset.soldOutLabel || 'Sold out';
    const fallbackColours = {black:'#151515',premium:'#111214',white:'#fff',ivory:'#f1eee7',cream:'#eee5d5',grey:'#999',gray:'#999',navy:'#1d2940',cobalt:'#275d9f',blue:'#496b91',badge:'#356fb5',green:'#536958',pink:'#e5bdc8',blush:'#e8c8cf',flame:'#a72b30',red:'#a52835',lemon:'#f1e44a',yellow:'#f1e44a',burgundy:'#6d2636',brown:'#65473d',chocolate:'#402925',beige:'#c8b7a0',purple:'#725a80'};

    section.querySelectorAll('.swatch-btn').forEach((button) => {
      if (button.style.getPropertyValue('--swatch-color')) return;
      const value = button.dataset.optionValue.toLowerCase();
      const match = Object.keys(fallbackColours).find((name) => value.includes(name));
      button.style.setProperty('--swatch-color', fallbackColours[match] || '#d8d3ca');
    });

    const findVariant = (options) => variants.find((variant) => variant.options.every((value, index) => value === options[index]));
    const resolveColourValue = (base, length) => {
      if (!splitLength) return base;
      const wantsLong = length === 'long';
      const values = [...new Set(variants.map((variant) => variant.options[colourPosition - 1]))];
      return values.find((value) => baseColour(value) === base && isLongColour(value) === wantsLong) || base;
    };
    const normalise = (value) => String(value || '').trim().toLowerCase();
    let filterGalleryByColour = section.dataset.showAllMediaInitially !== 'true';
    const updateGallery = (variant) => {
      if (!gallery) return;
      const items = [...gallery.querySelectorAll('[data-gallery-item]')];
      if (!filterGalleryByColour) {
        items.forEach((item, index) => {
          item.hidden = false;
          item.classList.toggle('is-active', index === 0);
        });
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb, index) => {
          thumb.hidden = false;
          thumb.classList.toggle('is-active', index === 0);
        });
        if (stage) stage.dataset.visibleCount = String(items.length);
        return;
      }
      if (!variant?.featuredMediaId) return;
      const selectedColourButton = section.querySelector('.swatch-btn.active');
      const selectedColour = colourPosition > 0 ? selected[colourPosition - 1] : (selectedColourButton?.dataset.optionValue || '');
      const matching = items.filter((item) => normalise(item.dataset.mediaColour) === normalise(selectedColour));
      const featured = items.find((item) => String(item.dataset.mediaId) === String(variant.featuredMediaId));
      const visible = matching.length
        ? [...new Set([featured, ...matching].filter(Boolean))]
        : (featured ? [featured] : []);
      const matchingMode = section.dataset.galleryColourMode === 'matching';

      items.forEach((item) => {
        const shouldShow = !matchingMode || visible.includes(item) || !selectedColour;
        item.hidden = !shouldShow;
        item.classList.toggle('is-active', item === visible[0]);
        if (!shouldShow) item.querySelector('video')?.pause();
      });
      if (featured) stage?.prepend(featured);

      gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        const linked = items.find((item) => item.dataset.mediaId === thumb.dataset.mediaId);
        thumb.hidden = matchingMode && linked ? linked.hidden : false;
        thumb.classList.toggle('is-active', linked === visible[0]);
      });
      if (stage) stage.dataset.visibleCount = String(visible.length || items.filter((item) => !item.hidden).length);
      if (window.matchMedia('(max-width: 900px)').matches) {
        if (stage && typeof stage.scrollTo === 'function') stage.scrollTo({ left: 0, behavior: 'auto' });
      }
      visible[0]?.querySelector('video')?.play().catch(() => {});
    };

    const updateSizeAvailability = () => {
      section.querySelectorAll('.size-btn').forEach((button) => {
        const candidate = [...selected];
        candidate[Number(button.dataset.optionPosition) - 1] = button.dataset.optionValue;
        const variant = findVariant(candidate);
        button.disabled = !variant?.available;
        button.classList.toggle('soldout', button.disabled);
        button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
      });
    };

    const render = (variant, updateUrl = true) => {
      if (!variant) return;
      variantInput.value = variant.id;
      if (price) price.innerHTML = variant.compareAtPrice ? `${escapeHtml(variant.price)} <s>${escapeHtml(variant.compareAtPrice)}</s>` : escapeHtml(variant.price);
      if (stickyPrice) stickyPrice.textContent = variant.price;
      if (stock) stock.innerHTML = variant.available ? `<span></span>${escapeHtml(stock.dataset.inStockLabel || 'In stock')}` : escapeHtml(stock.dataset.soldOutLabel || soldOutLabel);
      addButtons.forEach((button) => { if (button) { button.disabled = !variant.available; button.textContent = variant.available ? addLabel : soldOutLabel; } });
      updateGallery(variant);
      updateSizeAvailability();
      if (updateUrl) { const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
    };

    buttons.forEach((button) => button.addEventListener('click', () => {
      const position = Number(button.dataset.optionPosition);
      if (button.classList.contains('swatch-btn') && position === colourPosition) {
        filterGalleryByColour = true;
      }
      if (splitLength && button.classList.contains('swatch-btn') && position === colourPosition) {
        selected[position - 1] = resolveColourValue(button.dataset.baseColour || button.dataset.optionValue, selectedLength);
        selectedLength = isLongColour(selected[position - 1]) ? 'long' : 'short';
      } else {
        selected[position - 1] = button.dataset.optionValue;
      }
      buttons.filter((item) => Number(item.dataset.optionPosition) === position).forEach((item) => {
        const active = splitLength && item.classList.contains('swatch-btn') && position === colourPosition
          ? baseColour(selected[position - 1]) === (item.dataset.baseColour || item.dataset.optionValue)
          : item === button;
        item.classList.toggle('active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      let variant = findVariant(selected);
      if (!variant && button.classList.contains('swatch-btn')) {
        variant = variants.find((item) => item.options[position - 1] === selected[position - 1] && item.available)
          || variants.find((item) => item.options[position - 1] === selected[position - 1]);
        if (variant) variant.options.forEach((value, index) => { selected[index] = value; });
      }
      if (variant) {
        buttons.forEach((item) => {
          const itemPosition = Number(item.dataset.optionPosition);
          const active = splitLength && item.classList.contains('swatch-btn') && itemPosition === colourPosition
            ? baseColour(selected[itemPosition - 1]) === (item.dataset.baseColour || item.dataset.optionValue)
            : item.dataset.optionValue === selected[itemPosition - 1];
          item.classList.toggle('active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        selectedLength = splitLength && isLongColour(selected[colourPosition - 1]) ? 'long' : 'short';
        lengthButtons.forEach((item) => {
          const active = item.dataset.lengthValue === selectedLength;
          item.classList.toggle('active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        section.querySelectorAll('[data-product-option]').forEach((group) => {
          const active = group.querySelector('.active');
          const label = group.querySelector('.current-colour,.current-size');
          if (active && label) label.textContent = active.dataset.optionValue;
        });
        const currentLength = section.querySelector('.current-length');
        const activeLength = section.querySelector('[data-length-value].active');
        if (currentLength && activeLength) currentLength.textContent = activeLength.textContent.trim();
      }
      render(variant);
    }));

    lengthButtons.forEach((button) => button.addEventListener('click', () => {
      const currentBaseColour = baseColour(selected[colourPosition - 1]);
      const nextLength = button.dataset.lengthValue;
      const nextColourValue = resolveColourValue(currentBaseColour, nextLength);
      selected[colourPosition - 1] = nextColourValue;
      selectedLength = isLongColour(nextColourValue) ? 'long' : 'short';
      let variant = findVariant(selected);
      if (!variant) {
        variant = variants.find((item) => item.options[colourPosition - 1] === nextColourValue && item.available)
          || variants.find((item) => item.options[colourPosition - 1] === nextColourValue);
        if (variant) variant.options.forEach((value, index) => { selected[index] = value; });
      }
      lengthButtons.forEach((item) => {
        const active = item.dataset.lengthValue === selectedLength;
        item.classList.toggle('active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      buttons.forEach((item) => {
        const itemPosition = Number(item.dataset.optionPosition);
        const active = splitLength && item.classList.contains('swatch-btn') && itemPosition === colourPosition
          ? baseColour(selected[itemPosition - 1]) === (item.dataset.baseColour || item.dataset.optionValue)
          : item.dataset.optionValue === selected[itemPosition - 1];
        item.classList.toggle('active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      const currentColour = section.querySelector('.current-colour');
      const currentLength = section.querySelector('.current-length');
      if (currentColour) currentColour.textContent = baseColour(selected[colourPosition - 1]);
      if (currentLength) currentLength.textContent = button.textContent.trim();
      render(variant);
    }));
    render(findVariant(selected), false);

    const stickyBuy = section.querySelector('.mobile-sticky-buy');
    const primaryButton = section.querySelector('[data-add-to-cart]');
    if (stickyBuy && primaryButton && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        const shouldShow = window.matchMedia('(max-width: 900px)').matches && !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBuy.classList.toggle('is-visible', shouldShow);
      }, { threshold: 0.05 });
      observer.observe(primaryButton);
    }
  });
})();

document.querySelectorAll('[data-welcome-popup]').forEach((popup) => {
  const closeButton = popup.querySelector('[data-welcome-close]');
  const designMode = popup.dataset.designMode === 'true';
  const storageKey = 'timeoff-welcome-popup-closed';
  let wasClosed = false;
  try { wasClosed = localStorage.getItem(storageKey) === '1'; } catch (error) {}
  const shouldOpen = designMode || !wasClosed;

  const openPopup = () => {
    if (!shouldOpen || popup.open) return;
    if (typeof popup.showModal === 'function') popup.showModal();
    else popup.setAttribute('open', '');
    document.documentElement.classList.add('modal-open');
  };
  const closePopup = () => {
    if (typeof popup.close === 'function') popup.close();
    else popup.removeAttribute('open');
    document.documentElement.classList.remove('modal-open');
    if (!designMode) {
      try { localStorage.setItem(storageKey, '1'); } catch (error) {}
    }
  };

  window.setTimeout(openPopup, Number(popup.dataset.delay || 0));
  closeButton?.addEventListener('click', closePopup);
  popup.addEventListener('click', (event) => {
    if (event.target === popup) closePopup();
  });
  popup.addEventListener('close', () => document.documentElement.classList.remove('modal-open'));
});
